import type { LoggerContext, LoggerInterface } from './_types';

interface LoggerHandlerInterface extends LoggerInterface {
  addLogger: (name: string, logger: LoggerInterface) => void;
}

function LoggerHandler(): LoggerHandlerInterface {
  const loggers: Map<string, LoggerInterface> = new Map();

  const info = (message: string, context?: LoggerContext) => {
    loggers.forEach((logger) => {
      logger.info?.(message, context);
    });
  };

  const debug = (message: string, context?: LoggerContext) => {
    loggers.forEach((logger) => {
      logger.debug?.(message, context);
    });
  };

  const warn = (message: string, context?: LoggerContext) => {
    loggers.forEach((logger) => {
      logger.warn?.(message, context);
    });
  };

  const error = (message: string, context?: LoggerContext) => {
    loggers.forEach((logger) => {
      logger.error?.(message, context);
    });
  };

  const addLogger = (name: string, logger: LoggerInterface) => {
    loggers.set(name, logger);
  };

  return Object.freeze({
    info,
    debug,
    warn,
    error,
    addLogger,
  });
}

export { LoggerHandler };
